import { motion } from 'framer-motion';

export function Portfolio() {
  const projects = [
    {
      image:
        'https://public.readdy.ai/ai/img_res/d9683adc718e9fcd9fbf099e94817527.jpg',
      title: 'Fleet Vehicle Wrap',
      category: 'Vehicle Wraps',
      desc: 'Full wrap for local auto dealership',
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=Illuminated%20LED%20channel%20letter%20business%20sign%20mounted%20on%20modern%20commercial%20brick%20building%20storefront%20facade%20at%20twilight%20warm%20glowing%20letters%20visible%20against%20dark%20sky%20premium%20retail%20commercial%20real%20estate%20signage%20exterior%20photography%20high%20quality&width=800&height=600&seq=102&orientation=landscape',
      title: 'Channel Letters',
      category: 'Storefront Signage',
      desc: 'Illuminated exterior sign, retail center',
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=Professional%20trade%20show%20exhibition%20booth%20large%20format%20tension%20fabric%20graphic%20display%20backdrop%20corporate%20branding%20business%20convention%20hall%20modern%20signage%20exhibit%20marketing%20event%20professional%20photography%20clean%20design&width=800&height=600&seq=103&orientation=landscape',
      title: 'Trade Show Exhibit',
      category: 'Event Graphics',
      desc: 'Complete booth package, DFW expo',
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=Modern%20retail%20business%20exterior%20with%20custom%20dimensional%20acrylic%20letters%20above%20glass%20door%20entrance%20clean%20contemporary%20building%20architecture%20premium%20brand%20identity%20signage%20bright%20natural%20daylight%20exterior%20photography%20high%20quality%20commercial%20real%20estate&width=800&height=600&seq=104&orientation=landscape',
      title: 'Dimensional Lettering',
      category: 'Storefront Signage',
      desc: 'Architectural signs, office complex',
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=Large%20printed%20vinyl%20advertising%20banner%20displayed%20outdoors%20on%20commercial%20building%20exterior%20wall%20vivid%20orange%20white%20brand%20colors%20retail%20business%20marketing%20promotion%20clear%20blue%20sky%20backdrop%20professional%20photography%20commercial%20signage&width=800&height=600&seq=105&orientation=landscape',
      title: 'Grand Opening Banner',
      category: 'Banners & Displays',
      desc: 'Outdoor vinyl banner, restaurant launch',
    },
    {
      image:
        'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20interior%20hallway%20sleek%20brushed%20aluminum%20wayfinding%20directional%20signs%20mounted%20on%20wall%20professional%20ADA%20compliant%20sign%20system%20clean%20contemporary%20interior%20design%20photography%20architectural%20signage&width=800&height=600&seq=106&orientation=landscape',
      title: 'Wayfinding System',
      category: 'Directional Signs',
      desc: 'Full wayfinding package, medical campus',
    },
  ];

  return (
    <section id="portfolio" className="py-24 bg-gray-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-teal-400 text-sm font-semibold tracking-widest uppercase mb-3 block">
            Recent Projects
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Featured{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-orange-400">
              Work
            </span>
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            A sample of completed signage projects for Arlington, TX and DFW Metroplex businesses
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
            >
              <div className="w-full h-64 overflow-hidden bg-gray-800">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent">
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="text-teal-400 text-xs font-semibold mb-1">{project.category}</p>
                  <h3 className="text-white text-lg font-bold mb-0.5">{project.title}</h3>
                  <p className="text-gray-400 text-xs">{project.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-12 text-center"
        >
          <a
            href="tel:817-860-9310"
            className="inline-flex items-center space-x-3 text-white hover:text-teal-400 transition-colors cursor-pointer"
          >
            <div className="w-10 h-10 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-phone-line text-lg text-white"></i>
            </div>
            <span className="font-semibold">
              Want results like these? Call{' '}
              <span className="text-teal-400">817-860-9310</span>
            </span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
